<template>
  <div class="group-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-content" >
            <el-row>
              <el-col :span="5" class="group-left">
                <div class="search-mode" v-if="user.rank===0">
                  <input type="text" class="search-input" @keyup.enter="addressBookSearch" placeholder="关键字搜索" v-model="search" />
                  <el-button class="search-btn" icon="el-icon-search" @click="addressBookSearch"/>
                </div>
                <div class="where-group" :style="user.rank===1?'margin-top: 0':''">
                  <div v-if="user.rank===1" class="group-img"><svg-icon icon-class="shop" style="width: 100%;height: 100%"/></div>
                  <div v-if="user.rank===0" class="group-img" :style="{backgroundImage:'url(' + logoImg + ')'}"></div>
                  <div class="group-name">{{groupName}}</div>
                  <div class="group-info">
                    <el-tag type="success" size="mini"><i class="el-icon-s-custom"></i> 人员 {{empNum}}</el-tag>
                    <el-tag v-if="user.rank===0" type="warning" size="mini"><i class="el-icon-s-home"></i> 部门 {{deptNum}}</el-tag>
                  </div>
                </div>
                <div class="where-group-dept">
                  <div class="dept-item" v-if="user.rank===0" @click="getGroupDetail(user.dGroupid,user.group_abbname)">
                    <svg-icon icon-class="arch"/> 组织架构
                  </div>
                  <div class="dept-item branch" v-if="user.rank===0" @click="getDeptDetail(user.dDeptid)">
                    <svg-icon icon-class="branch"/> {{user.dept_name}}
                  </div>
                  <div class="dept-item" v-if="user.rank===1">
                    <svg-icon icon-class="arch"/> 组织架构
                  </div>
                  <div class="dept-item branch" v-if="user.rank===1">
                    <svg-icon icon-class="branch"/> {{user.name}}
                  </div>
<!--                  <div class="dept-item" @click="getDealerList">-->
<!--                    <svg-icon icon-class="dealer"/> 经销商-->
<!--                  </div>-->
                </div>
                <div class="other-group">
                  <div class="group-item" v-for="group in groupBreadcrumb" v-if="group.groupid!==user.dGroupid" @click="getGroupDetail(group.groupid,group.group_name)">
                    <div class="group-img" :style="{backgroundImage:'url(' + group.logo_url + ')'}"></div>
                    <div class="group-name">{{group.group_name}}</div>
                  </div>
                </div>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <!--<ul class="group-breadcrumb">
                  <li>
                    <el-button @click="getGroupDetail(user.dGroupid)" type="text">{{groupName}}</el-button>
                    <el-button v-for="dept in deptBreadList" @click.native="getGroupDetail(dept.id,dept.name)"  type="text">{{dept.name}}</el-button>
                  </li>
                </ul>-->
                <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: normal;font-size: 13px;" v-if="user.rank===0">
                  <el-breadcrumb-item @click.native="getGroupDetail(groupId,groupName)" style="cursor: pointer;float:none;">{{groupName}}</el-breadcrumb-item>
                  <el-breadcrumb-item v-for="dept in deptBreadList" style="cursor: pointer;float:none;">
                    <span @click="getDeptDetail(dept.id,dept.name)">{{dept.name}}</span>
                  </el-breadcrumb-item>
                </el-breadcrumb>
                <ul class="group-list" v-if="user.rank===0">
                  <li v-for="dept in deptNameAndNum" @click="getDeptDetail(dept.deptid,dept.dept_name)">{{dept.dept_name}}（{{dept.emp_num}}）</li>
                  <li v-for="dept2 in deptEmpList">
                    <div class="group-user" @click="getUserDetail(dept2.userid)">
                      <el-avatar :size="45" shape="square" v-if="dept2.photo_url!==null&&dept2.photo_url!==''&&dept2.photo_url!==undefined" :src="dept2.photo_url"/>
                      <el-avatar :size="45" shape="square" v-if="dept2.photo_url===null||dept2.photo_url===''||dept2.photo_url===undefined" :src="dept2.dSex==='女'?women:men"/>
                      <div class="user-name">{{dept2.name}}</div>
                      <div class="user-position">{{dept2.position_name}}</div>
                    </div>
                  </li>
                </ul>
                <ul class="group-list" v-if="user.rank===1">
                  <li v-for="dept2 in deluserlst">
                    <div class="group-user" @click="getDealerUserDetail(dept2)">
                      <el-avatar :size="45" shape="square" v-if="dept2.photo!==null&&dept2.photo!==''&&dept2.photo!==undefined" :src="dept2.photo"/>
                      <el-avatar :size="45" shape="square" v-if="dept2.photo===null||dept2.photo===''||dept2.photo===undefined" :src="dept2.sex==='女'?women:men"/>
                      <div class="user-name">{{dept2.name}}</div>
                      <div class="user-position">{{dept2.positionname!==null&&dept2.positionname!==undefined&&dept2.positionname!==''?dept2.positionname:dept2.username}}</div>
                    </div>
                  </li>
                </ul>

              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="员工信息"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-row style="padding:10px 20px 20px 20px" v-loading="detailLoading">
        <div style="margin-bottom:10px;">
          <span class="user-item">姓名：<span>{{userDetail.dName}}</span></span>
          <span class="user-item" style="margin-left: 30px;">性别：<span>{{userDetail.dSex}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dBirthday!==''">生日：<span>{{userDetail.dBirthday}}<span v-if="userDetail.dBdtype===0" style="color: #20a0ff">(公历)</span><span style="color: #20a0ff" v-else>(农历)</span></span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dBirthday===''">生日：<span>未填写</span></span>
        </div>
        <div style="margin-bottom:10px;">
          <span class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty!==''">籍贯：<span>{{userDetail.dProvince}}/{{userDetail.dCity}}/{{userDetail.dCounty}}</span></span>
          <span class="user-item" v-if="userDetail.dProvince==='' && userDetail.dCity==='' && userDetail.dCounty===''">籍贯：<span>未填写</span></span>
          <span class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity==='' && userDetail.dCounty===''">籍贯：<span>{{userDetail.dProvince}}</span></span>
          <span class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty===''">籍贯：<span>{{userDetail.dProvince}}/{{userDetail.dCity}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dEmail!==''">邮箱：<span>{{userDetail.dEmail}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dEmail===''">邮箱：<span>未填写</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dWchat!==''">微信：<span>{{userDetail.dWchat}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dWchat===''">微信：<span>未填写</span></span>
        </div>
        <div style="margin-bottom:10px;">
          <span class="user-item">手机号：<span>{{userDetail.dUsername}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dTel!==''">联系电话：<span>{{userDetail.dTel}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="userDetail.dTel===''">联系电话：<span>未填写</span></span>
          <span class="user-item" style="margin-left: 30px;">职位：<span>{{userDetail.position_name}}</span></span>
        </div>
        <div style="margin-bottom:10px;">
          <span class="user-item">部门：<span>{{userDetail.dept_name}}</span></span>
          <span class="user-item" style="margin-left: 30px;">公司：<span>{{userDetail.group_name}}</span></span>
        </div>
        <!--<el-col :span="7" :offset="1">
          <div class="user-item">
            姓名：<span>{{userDetail.dName}}</span>
          </div>
          <div class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty!==''">籍贯：<span>{{userDetail.dProvince}}/{{userDetail.dCity}}/{{userDetail.dCounty}}</span></div>
          <div class="user-item" v-if="userDetail.dProvince==='' && userDetail.dCity==='' && userDetail.dCounty===''">籍贯：<span>未填写</span></div>
          <div class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity==='' && userDetail.dCounty===''">籍贯：<span>{{userDetail.dProvince}}</span></div>
          <div class="user-item" v-if="userDetail.dProvince!=='' && userDetail.dCity!=='' && userDetail.dCounty===''">籍贯：<span>{{userDetail.dProvince}}/{{userDetail.dCity}}</span></div>
          <div class="user-item" v-if="userDetail.dEmail!==''">
            <el-tooltip placement="top">
              <div slot="content">
                {{userDetail.dEmail}}
              </div>
              <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;">邮箱：<span>{{userDetail.dEmail}}</span></span>
            </el-tooltip>
          </div>
          <div class="user-item" v-if="userDetail.dEmail===''">邮箱：<span>未填写</span></div>
          <div class="user-item">部门：<span>{{userDetail.dept_name}}</span></div>
        </el-col>
        <el-col :span="7" :offset="1">
          <div class="user-item">
            性别：<span>{{userDetail.dSex}}</span>
          </div>
          <div class="user-item">手机号：<span>{{userDetail.dUsername}}</span></div>
          <div class="user-item" v-if="userDetail.dWchat!==''">微信：<span>{{userDetail.dWchat}}</span></div>
          <div class="user-item" v-if="userDetail.dWchat===''">微信：<span>未填写</span></div>
          <div class="user-item">职位：<span>{{userDetail.position_name}}</span></div>
        </el-col>
        <el-col :span="7" :offset="1">
          <div class="user-item" v-if="userDetail.dBirthday!==''">生日：<span>{{userDetail.dBirthday}}<span v-if="userDetail.dBdtype===0" style="color: #20a0ff">(公历)</span><span style="color: #20a0ff" v-else>(农历)</span></span></div>
          <div class="user-item" v-if="userDetail.dBirthday===''">生日：<span>未填写</span></div>
          <div class="user-item" v-if="userDetail.dTel!==''">联系电话：<span>{{userDetail.dTel}}</span></div>
          <div class="user-item" v-if="userDetail.dTel===''">联系电话：<span>未填写</span></div>
          <div class="user-item" v-if="userDetail.group_name!==''">
            <el-tooltip placement="top">
              <div slot="content">
                {{userDetail.group_name}}
              </div>
              <span style="text-overflow:ellipsis; overflow: hidden;white-space: nowrap;">公司：<span>{{userDetail.group_name}}</span></span>
            </el-tooltip>
          </div>
        </el-col>-->
      </el-row>
    </el-dialog>
    <el-dialog
      title="员工信息"
      :visible.sync="dialogDelVisible"
      width="40%">
      <el-row style="padding:10px 20px 20px 20px">
        <div style="margin-bottom:10px;">
          <span class="user-item">姓名：<span>{{deluser.name}}</span></span>
          <span class="user-item" style="margin-left: 30px;">性别：<span>{{deluser.sex}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.birthday!==''">生日：<span>{{deluser.birthday}}<span v-if="deluser.bdtype===0" style="color: #20a0ff">(公历)</span><span style="color: #20a0ff" v-else>(农历)</span></span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.birthday===''">生日：<span>未填写</span></span>
        </div>
        <div style="margin-bottom:10px;">
          <span class="user-item" style="margin-right: 30px;">职位：<span>{{deluser.positionname!==null&&deluser.positionname!==undefined&&deluser.positionname!==''?deluser.positionname:'N/A'}}</span></span>
          <span class="user-item" v-if="deluser.province!=='' && deluser.city!=='' && deluser.county!==''">籍贯：<span>{{deluser.province}}/{{deluser.city}}/{{deluser.county}}</span></span>
          <span class="user-item" v-if="deluser.province==='' && deluser.city==='' && deluser.county===''">籍贯：<span>未填写</span></span>
          <span class="user-item" v-if="deluser.province!=='' && deluser.city==='' && deluser.county===''">籍贯：<span>{{deluser.province}}</span></span>
          <span class="user-item" v-if="deluser.province!=='' && deluser.city!=='' && deluser.county===''">籍贯：<span>{{deluser.province}}/{{deluser.city}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.email!==''">邮箱：<span>{{deluser.email}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.email===''">邮箱：<span>未填写</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.wchat!==''">微信：<span>{{deluser.wchat}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.wchat===''">微信：<span>未填写</span></span>
        </div>
        <div style="margin-bottom:10px;">
          <span class="user-item">手机号：<span>{{deluser.username}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.tel!==''">联系电话：<span>{{deluser.tel}}</span></span>
          <span class="user-item" style="margin-left: 30px;" v-if="deluser.tel===''">联系电话：<span>未填写</span></span>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getGroupDept, getDealerGroupReport, addressBookSearch, getDeptEmp, getDeptDept, getGroupReport } from '@/api/group/group'
import { getUserDetail } from '@/api/work'
import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'
export default {
  name: 'group',
  computed: {
    user: getUser
  },
  data() {
    return {
      men: men,
      women: women,
      loading: false,
      search: '',
      groupBreadcrumb: [],
      groupName: '',
      groupId: '',
      deptNum: 0,
      empNum: 0,
      logoImg: '',
      deptNameAndNum: [],
      deptEmpList: [],
      deptBreadList: [],
      userDetail: {},
      dialogVisible: false,
      detailLoading: false,
      deluserlst: [],
      deluser: {},
      dialogDelVisible: false
    }
  },
  created() {
    if (this.user.rank === 0) {
      this.getGroupData()
      this.getDeptDetail(this.user.dDeptid,this.user.dept_name)
    } else {
      this.getDealerGroup()
    }
  },
  methods: {
    getDealerGroup() {
      getDealerGroupReport({ delid: this.user.delid }).then(response => {
        // this.groupBreadcrumb = response.data
        this.groupName = response.data.name
        this.empNum = response.data.usercount
        this.deluserlst = response.data.userlst
      })
    },
    getGroupData() {
      const _this = this
      getGroupReport().then(response => {
        _this.groupBreadcrumb = response.data
        for (let i = 0; i < _this.groupBreadcrumb.length; i++) {
          if (_this.groupBreadcrumb[i].groupid === _this.user.dGroupid) {
            _this.groupName = _this.groupBreadcrumb[i].group_name
            _this.groupId = _this.groupBreadcrumb[i].groupid
            _this.deptNum = _this.groupBreadcrumb[i].dept_num
            _this.empNum = _this.groupBreadcrumb[i].emp_num
            _this.logoImg = _this.groupBreadcrumb[i].logo_url
            break
          }
        }
      })
    },
    getGroupDetail(groupId, groupName) { // 获取组织详情
      const data = {
        groupid: groupId
      }
      this.loading = true
      getGroupDept(data).then(response => {
        this.deptNameAndNum = response.data
        this.deptEmpList = []
        this.groupId = groupId
        this.groupName = groupName
        this.deptBreadList = []
        this.loading = false
        for (const item of this.groupBreadcrumb) {
          if (item.groupid === groupId) {
            this.deptNum = item.dept_num
            this.empNum = item.emp_num
            break
          }
        }
      })
    },
    getDeptDetail(deptId, deptName) { // 获取部门详情
      this.loading = true
      const data1 = {
        deptid: deptId
      }
      const data2 = {
        deptid: deptId,
        page: 1,
        limit: 500
      }
      const _this = this
      getDeptDept(data1).then(response => {
        _this.deptNameAndNum = response.data
        getDeptEmp(data2).then(response2 => {
          _this.deptEmpList = response2.data
          _this.loading = false
          const dept = {
            name: deptName,
            id: deptId
          }
          let falge = false
          let index = 0
          for (let i = 0; i < this.deptBreadList.length; i++) {
            if (deptName === this.deptBreadList[i].name) {
              falge = true
              index = i
              break
            }
          }
          if (!falge) {
            this.deptBreadList.push(dept)
          } else {
            const j = this.deptBreadList.length - (index + 1)
            for (let k = 0; k < j; k++) {
              this.deptBreadList.pop()
            }
          }
        })
      })
    },
    getDealerList() {
      /* console.log("获取经销商列表")*/
    },
    addressBookSearch() {
      this.loading = true
      if (this.search === '') {
        this.loading = false
        return false
      }
      const data = {
        keyword: this.search
        /* groupId: this.groupId */
      }
      const _this = this
      addressBookSearch(data).then(response => {
        _this.deptNameAndNum = response.data.deptList
        _this.deptEmpList = response.data.userList
        _this.loading = false
      }).catch(() => {
        _this.loading = false
      })
    },
    getUserDetail(userId) {
      this.detailLoading = true
      this.dialogVisible = true
      getUserDetail({ userid: userId }).then(response => {
        this.userDetail = response.data.user
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    getDealerUserDetail(row) {
      this.deluser = row
      this.dialogDelVisible = true
    },
    handleClose(done) {
      this.userDetail = {}
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.group-container {
  .tcf-row{
    .card{
      .card-body{
        .card-content{
          .group-left{
            padding-right: 30px;
          }
          .search-mode{
            width: 100%;
            position: relative;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
          .where-group{
            margin-top: 20px;
            width: 100%;
            position: relative;
            padding-left: 60px;
            .group-img{
              width: 50px;
              height: 50px;
              background-position: center center;
              background-size: cover;
              background-repeat: no-repeat;
              border-radius: 2px;
              position: absolute;
              left: 0;
              top:0;
            }
            .group-name{
              font-size: 14px;
              color:#404852;
              font-weight: 500;
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              position: relative;
              line-height: 24px;
            }
            .group-info{
              width: 100%;
              position: relative;
              margin-top: 6px;
            }
          }
          .where-group-dept{
            margin-top: 20px;
            width: 100%;
            position: relative;
            .dept-item{
              cursor: pointer;
              padding: 6px 14px;
              border-radius: 2px;
              font-size: 12px;
              position: relative;
              .svg-icon{
                width: 16px!important;
                margin-right: 10px;
                color:#409EFF;
              }
              &.branch{
                padding: 0 0 0 43px;
                height: 34px;
                line-height: 34px;
                .svg-icon{
                  width: 10px!important;
                  left: 21px;
                  top:0;
                  position: absolute;
                }
              }
              &:hover{
                background: #f5f7fa;
              }
            }
          }
          .other-group{
            width: 100%;
            margin-top: 10px;
            position: relative;
            .group-item{
              width: 100%;
              position: relative;
              padding-left: 44px;
              line-height: 36px;
              cursor: pointer;
              border-radius: 2px;
              .group-name{
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                position: relative;
                border-top: 1px solid #f5f7fa;
                &:after{
                  line-height: 36px;
                  font-family: element-icons!important;
                  content: '\e6e0';
                  color:#999;
                  position: absolute;
                  top:0;
                  right: 10px;
                }
              }
              .group-img{
                width: 24px;
                height: 24px;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                border-radius: 2px;
                position: absolute;
                left: 10px;
                top:6px;
              }
              &:hover{
                background: #f5f7fa;
              }
            }

          }
          .group-breadcrumb{
            width: 100%;
            position: relative;
            list-style: none;
            margin: 0;
            padding: 0 0 0 10px;
            border-bottom: 1px solid #f5f7fa;
            li{
              float: left;
              margin-right: 10px;
              &:after{
                content: '/';
                margin-left: 10px;
                color:#eee;
              }
              &:last-child{
                margin-right: 0;
                &:after{
                  content: none;
                }
              }
            }
            &:after{
              content: ' ';
              display: table;
              clear: both;
            }
          }
          .group-list{
            width: 100%;
            position: relative;
            margin: 10px 0;
            padding: 0;
            list-style: none;
            li{
              width: 100%;
              line-height: 60px;
              border-radius: 2px;
              padding: 0 10px;
              cursor: pointer;
              .group-user{
                width: 100%;
                position: relative;
                height: 65px;
                overflow: hidden;
                padding-left: 55px;
                .el-avatar{
                  position: absolute;
                  top: 10px;
                  left: 0;
                }
                .user-name{
                  margin-top: 15px;
                  line-height: 20px;
                }
                .user-position{
                  color:#999;
                  font-size: 12px;
                  line-height: 16px;
                }
              }
              &:hover{
                background: #f5f7fa;
              }
            }
          }
        }
      }
    }
  }
  .user-item{
    color:#99a9bf;
    margin-bottom: 20px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    span{
      font-weight: 400;
      color: #606266;
    }
    i{
      margin-right: 5px;
    }
  }
}
</style>
